import { useMemo } from 'react';

import { FRONTEND_FEATURES } from '@/permissions/frontend-features';
import { useFrontendFeature } from '@/permissions/useFrontendFeature';
import { OWNER_GROUP_ROLES } from '@/utils/roles';
import { useRoles } from '@hooks/useRoles';
import {
  APPROVALS_SEGMENT,
  SEGMENTS,
} from '@pages/Expenses/TransactionsPage/transaction.constants.ts';

export const useTransactionApprovals = () => {
  const { hasAnyRole } = useRoles();
  const isOwner = hasAnyRole(OWNER_GROUP_ROLES);
  // Approvals are payments waiting on the owner, so the segment goes with payments.
  const canPay = useFrontendFeature(FRONTEND_FEATURES.PaymentsUI);

  const segments = useMemo(
    () => (isOwner && canPay ? [...SEGMENTS, APPROVALS_SEGMENT] : SEGMENTS),
    [isOwner, canPay],
  );

  return { isOwner, segments };
};
